import React from 'react';
import { Link } from 'gatsby';
import Layout from '../components/layout';
import SEO from '../components/seo';

function BlogIndex(_ref) {
  var _data$site, _data$site$siteMetada, _data$site2, _data$site2$siteMetad;

  var data = _ref.data,
      location = _ref.location;
  var blogName = (_data$site = data.site) === null || _data$site === void 0 ? void 0 : (_data$site$siteMetada = _data$site.siteMetadata) === null || _data$site$siteMetada === void 0 ? void 0 : _data$site$siteMetada.blogName;
  var blogDescription = (_data$site2 = data.site) === null || _data$site2 === void 0 ? void 0 : (_data$site2$siteMetad = _data$site2.siteMetadata) === null || _data$site2$siteMetad === void 0 ? void 0 : _data$site2$siteMetad.blogDescription;
  var posts = data.allMarkdownRemark.edges;
  return /*#__PURE__*/React.createElement(Layout, {
    location: location,
    title: blogName
  }, /*#__PURE__*/React.createElement(SEO, {
    title: "All posts"
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-center italic mb-16 w-64 mx-auto text-base"
  }, blogDescription), /*#__PURE__*/React.createElement(React.Fragment, null, posts.map(function (_ref2) {
    var _node$frontmatter, _node$fields, _node$fields2, _node$fields3, _node$frontmatter2, _node$frontmatter3;

    var node = _ref2.node;
    var title = ((_node$frontmatter = node.frontmatter) === null || _node$frontmatter === void 0 ? void 0 : _node$frontmatter.title) || ((_node$fields = node.fields) === null || _node$fields === void 0 ? void 0 : _node$fields.slug);
    return /*#__PURE__*/React.createElement("div", {
      className: "border-l-2 border-solid border-cerise-700 pl-4 md:ml-3 pr-2",
      key: (_node$fields2 = node.fields) === null || _node$fields2 === void 0 ? void 0 : _node$fields2.slug
    }, /*#__PURE__*/React.createElement("h2", {
      className: "mt-10 text-2xl text-cerise-700 leading-tight"
    }, /*#__PURE__*/React.createElement(Link, {
      to: '/blog' + ((_node$fields3 = node.fields) === null || _node$fields3 === void 0 ? void 0 : _node$fields3.slug),
      className: "no-underline"
    }, title)), /*#__PURE__*/React.createElement("small", {
      className: "text-sm text-gray-700"
    }, (_node$frontmatter2 = node.frontmatter) === null || _node$frontmatter2 === void 0 ? void 0 : _node$frontmatter2.date), /*#__PURE__*/React.createElement("p", {
      className: "text-lg my-3",
      dangerouslySetInnerHTML: {
        __html: ((_node$frontmatter3 = node.frontmatter) === null || _node$frontmatter3 === void 0 ? void 0 : _node$frontmatter3.description) || node.excerpt
      }
    }));
  })));
}

export default BlogIndex;
var pageQuery = "202565256";